<ol class="m-0 flex list-none items-center gap-3 p-0">
  <li
    *ngFor="let step of steps; let i = index; let last = last"
    class="flex min-w-0 items-center gap-3"
    [ngClass]="last ? 'flex-initial' : 'flex-1'"
    [attr.aria-current]="step.state === 'current' ? 'step' : null"
  >
    <span
      class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-medium"
      [ngClass]="markerClasses[step.state]"
      aria-hidden="true"
    >
      <mat-icon *ngIf="step.state === 'complete'" class="tl-icon-sm">check</mat-icon>
      <mat-icon *ngIf="step.state === 'error'" class="tl-icon-sm">close</mat-icon>
      <mat-progress-spinner
        *ngIf="step.state === 'current' && busy"
        mode="indeterminate"
        [diameter]="16"
        [strokeWidth]="3"
      ></mat-progress-spinner>
      <span *ngIf="step.state === 'pending' || (step.state === 'current' && !busy)">{{ i + 1 }}</span>
    </span>

    <span class="min-w-0 truncate text-sm" [ngClass]="labelClasses[step.state]" [attr.title]="step.label">{{
      step.label
    }}</span>

    <!-- The connector belongs to the step it leaves, so it fills once that step is complete. -->
    <span
      *ngIf="!last"
      class="h-0.5 min-w-6 flex-1 rounded-full"
      [ngClass]="step.state === 'complete' ? 'bg-theme-600' : 'bg-gray-200'"
      aria-hidden="true"
    ></span>
  </li>
</ol>
